<template>
  <div
    class="content-index"
  >
    <div class="content-index__search">
      <div class="filter__search">
        <text-input
          ref="input"
          :label="$t('content.index.search.' + type)"
          name="filter-search"
          autocomplete="off"
          v-model="inputValue"
          hide-label
          hide-mandatory-marker
        />
        <div class="input__button input__button--icon_search" />
      </div>
    </div>

    <div class="content-index__header">
      <content-index-header
        :section-id-prefix="`content-index__${type}_`"
      />
    </div>

    <div class="content-index__list">
      <div
        v-for="letterEntry in listKeys"
        :key="`h${letterEntry}`"
        :data-nav-anchor="letterEntry"
        :data-nav-disabled="!listData[letterEntry].length ? 'disabled' : null"
      >
        <div
          class="content-index__head"
          :class="{'content-index__head--empty': !listData[letterEntry].length}"
        >
          {{ letterEntry }}
        </div>
        <div
          class="content-index__items"
          :id="`content-index__${type}_${letterEntry}`"
        >
          <component
            v-for="entry in listData[letterEntry]"
            :key="entry.link + '_'+ entry.name"
            :is="entry.link ? 'a' : 'span'"
            :href="entry.link"
            class="content-index__item"
            :rel="entry.link ? entry.follow : null"
          >
            {{ entry.name }}
          </component>
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
  import {Vue, Options, Prop} from 'vue-property-decorator';
  import TextInput from '../../../bps/components/input/TextInput.vue';

  type IndexEntry = {
    follow: 'follow'|'nofollow',
    link: string,
    name: string,
    normalizedName: string,
    valid: boolean
  }
  type IndexData = {
    [key: string]: IndexEntry[]
  }

  @Options({
    name: 'content-index',
    components: {
      TextInput
    }
  })
  export default class ContentIndex extends Vue {
    @Prop()
    readonly contentData: {groupedIndex: IndexData};
    @Prop()
    readonly type: string;

    inputValue: string = '';
    listKeys: string[] = [];

    created() {
      this.listKeys = Object.keys(this.contentData.groupedIndex).sort((a, b) => {
        // sort numbers after letters
        if (!isNaN(parseInt(a))) {
          a = 'z' + a;
        }
        if (!isNaN(parseInt(b))) {
          b = 'z' + b;
        }
        return a > b ? 1 : -1;
      });
    }

    get searchValue() {
      return this.inputValue.trim();
    }

    get listData(): IndexData {
      const regex = new RegExp(this.searchValue, 'gi');
      const result = {};
      this.listKeys.forEach((letter) => {
        result[letter] = this.contentData.groupedIndex[letter].filter(entry => {
          return this.searchValue === '' || entry.normalizedName.match(regex) || entry.name.match(regex);
        });
      });

      return result;
    }
  }
</script>
